import { psCollection } from "./powersync-collection.js";
import {
  paymentMethodConfigSchema,
  auditLogSchema,
  subscriptionPlanSchema,
  billingCycleSchema,
  subscriptionPaymentSchema,
  modulePresetSchema,
  subscriptionDiscountSchema,
  discountCodeSchema,
  type PaymentMethodConfig,
  type AuditLog,
  type SubscriptionPlan,
  type BillingCycle,
  type SubscriptionPayment,
  type ModulePreset,
  type SubscriptionDiscount,
  type DiscountCode,
} from "../schemas/platform.js";

// Platform-wide payment method templates (admin-managed, e.g. "Wave Pay
// QR", "KBZ Bank") — writes require a platform-scope (admin) token.
export const paymentMethodConfigsCollection = psCollection("payment_method_configs", paymentMethodConfigSchema);

// Immutable (Postgres trigger blocks UPDATE/DELETE) — read via this
// collection; sync-api's route exists for symmetry but update/delete will
// always fail at the database level, which is intentional.
export const auditLogCollection = psCollection("audit_log", auditLogSchema);

export const subscriptionPlansCollection = psCollection("subscription_plans", subscriptionPlanSchema);

export const billingCyclesCollection = psCollection("billing_cycles", billingCycleSchema);

// Onboarding presets (business-type -> recommended module set) — admin-
// managed reference data. Owner Portal reads this to power the Modules
// page's preset selector but never writes to it.
export const modulePresetsCollection = psCollection("module_presets", modulePresetSchema);

// The payment-verification queue: owners insert (business_id forced to
// their own by sync-api), admins review/approve/reject (platform-scope
// tokens bypass the tenant check).
export const subscriptionPaymentsCollection = psCollection("subscription_payments", subscriptionPaymentSchema);

// Standing discount rules (global or per-business) — admin-managed, read
// by owner-portal's billing calculation to auto-apply the best match.
export const subscriptionDiscountsCollection = psCollection("subscription_discounts", subscriptionDiscountSchema);

// Redeemable discount codes — admin-managed; owners look one up by code at
// payment time (BillingTab.tsx). redeemed_count only increments server-side
// on payment approval (see the /approve endpoint), never written directly
// by owner-portal.
export const discountCodesCollection = psCollection("discount_codes", discountCodeSchema);
